import { NON_MECHANICAL_BASE } from './_shared'

/** Perfil ZANJAS (electrical_trenches). No-mecánico + screenshot propio. */
export default {
  ...NON_MECHANICAL_BASE,
  design: {
    ...NON_MECHANICAL_BASE.design,
    screenshotName: 'trench.png',
    codePrefix:     'trench',
    layerIcon:      'road',          // icono de las capas del pictograma
  },
}
